import { createActions } from "redux-actions";

export const constants = {
  FETCH_RECOGNITIONS_LIST: "FETCH_RECOGNITIONS_LIST",
};

export const actions = createActions({
  FETCH_RECOGNITIONS_LIST: {
    REQUEST: () => ({}),
    SUCCESS: ({ source, data }) => ({ source, data }),
    FAILURE: ({ source, message }) => ({ source, message }),
  },
});
